import { useEffect, useLayoutEffect, useRef } from 'react';
import { unstable_useBlocker as useBlocker } from 'react-router-dom';
import UIActions from '../ui/UIActions';
import usePreventLeaving from './usePreventLeaving';
import { useAppDispatch } from '../app/redux/useAppSelector';

const useBeforeRouterLeaveConfirmWithModal = ({
  skip,
  onConfirm,
  title,
  cancelButtonText,
  confirmButtonText,
  message,
}: {
  skip?: boolean;
  onConfirm(): void | Promise<void>;
  cancelButtonText?: string;
  confirmButtonText?: string;
  message?: React.ReactNode;
  title: string;
}) => {
  const onConfirmRef = useRef(onConfirm);
  useLayoutEffect(() => {
    onConfirmRef.current = onConfirm;
  });

  const dispatch = useAppDispatch();

  usePreventLeaving({ skip });
  const blocker = useBlocker(!skip);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      dispatch(
        UIActions.confirmModal({
          title,
          message,
          cancelButtonText,
          confirmButtonText,
          close() {
            dispatch(UIActions.closeModal());
            blocker.proceed?.();
          },
          onConfirm: onConfirmRef.current,
        }),
      );
    }
  }, [blocker, cancelButtonText, confirmButtonText, dispatch, message, title]);
};

export default useBeforeRouterLeaveConfirmWithModal;
